import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  postMethod3,
  postMethodForReset,
} from "../../services/ApiCallMethods";

export const requestResetPassword = createAsyncThunk(
  "reset/requestResetPassword",
  async ({ email, isResendOTP = false }, { rejectWithValue }) => {
    try {
      const response = await postMethodForReset(
        `/api/auth/request-reset-password?isResendOTP=${isResendOTP}`,
        { email }
      );
      return response.message;
    } catch (err) {

      let message = "Reset request failed.";
      try {
        if (err?.response?.data?.message) {
          const apiMsg = err.response.data.message;
          if (typeof apiMsg === "string") {
            message = apiMsg;
          } else if (typeof apiMsg === "object") {
            const firstKey = Object.keys(apiMsg)[0];
            message = apiMsg[firstKey];
          }
        } else if (err.message) {
          message = err.message;
        }
      } catch (e) {
        console.error("Error extracting API message", e);
      }

      return rejectWithValue(message);
    }
  }
);


// Thunk for verifying OTP
export const verifyOtp = createAsyncThunk(
  "reset/verifyOtp",
  async ({ email, otp }, { rejectWithValue }) => {
    try {
      const response = await postMethodForReset("/api/auth/verify-otp", {
        email,
        otp,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "OTP verification failed."
      );
    }
  }
);

// Thunk for resetting password
export const resetPassword = createAsyncThunk(
  "reset/resetPassword",
  async ({token, email, otp, newPassword }, { rejectWithValue }) => {
    try {
      const response = await postMethodForReset("/api/auth/reset-password", {
        email,
        otp,
        newPassword,
        token,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Password reset failed."
      );
    }
  }
);

export const changePassword = createAsyncThunk(
  "reset/changePassword",
  async (payload, { rejectWithValue }) => {
    const response = await postMethod3(`/api/auth/change-password`, payload, {
      suppress401: true,
    });
    if (response?.__errorHandled) {
      return rejectWithValue(response.message || "Current password incorrect.");
    }

    return response;
  }
);

const resetSlice = createSlice({
  name: "reset",
  initialState: {
    loading: false,
    error: null,
    success: false,
    otpVerified: false,
    passwordReset: false,
    changePassword: false,
    changePasswordError: null,
  },
  reducers: {
    resetResetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.otpVerified = false;
      state.passwordReset = false;
      state.changePassword = false;
      state.changePasswordError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestResetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(requestResetPassword.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(requestResetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      // verifyOtp
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.otpVerified = false;
      })
      .addCase(verifyOtp.fulfilled, (state) => {
        state.loading = false;
        state.otpVerified = true;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.otpVerified = false;
      })
      // resetPassword
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.passwordReset = false;
      })
      .addCase(resetPassword.fulfilled, (state) => {
        state.loading = false;
        state.passwordReset = true;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.passwordReset = false;
      })
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.loading = false;
        state.changePassword = true;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.changePasswordError = action.payload;
        state.changePassword = false;
      });
  },
});

export const { resetResetState } = resetSlice.actions;
export default resetSlice.reducer;
